import React, { useState, useEffect, useRef } from "react";

import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useConfig } from "./ConfigContext";
import { averageString, colorPalette100 } from "./globalVariables";
import { Modal, Table } from "react-bootstrap";
import { calcProvision, formatCurrency } from "./pureFunctions";

export default function NutzergrafikProvisionHSum({ availableUsers, users, estates, setSelectedUser, statConfig }) {
   const [graphData, setGraphData] = useState();
   const [selectedData, setSelectedData] = useState();

   const [total, setTotal] = useState();
   const config = useConfig();

   const kategorien = { aktiv: [], verkauft: [], gescheitert: [] };

   useEffect(() => {
      if (estates && users && availableUsers) {
         console.log(estates);
         const kategorien = { aktiv: [], verkauft: [], gescheitert: [] };
         let newTotal = {
            aktiv: { color: "#5B8DEF", price: 0, amount: 0 }, //5B8DEF
            verkauft: { color: "#5FD07E", price: 0, amount: 0 },
            gescheitert: { color: "#F26D6D", price: 0, amount: 0 },
         };
         let userdata = structuredClone(availableUsers);

         estates.forEach((item) => {
            newTotal[item.myStatus].price += calcProvision(item, config);
            newTotal[item.myStatus].amount++;
            let itemuser = item.benutzer;

            if (!userdata[itemuser]) {
               userdata[itemuser] = structuredClone(kategorien);
            }

            userdata[itemuser][item.myStatus].push(item);
         });
         console.log(newTotal);

         setTotal(newTotal);
         console.log(userdata);
         const aldfb = Object.keys(userdata).map((item) => {
            return {
               ["name"]: users[item] ? users[item].Kuerzel : item,
               ...Object.keys(kategorien).reduce((oldObj, keyItem) => {
                  return {
                     ...oldObj,
                     [keyItem]: userdata[item][keyItem]
                        ? userdata[item][keyItem].reduce((oldObj, itemObj) => {
                             return parseFloat(oldObj) + calcProvision(itemObj, config);
                          }, 0)
                        : 0,
                  };
               }, {}),
               ["data"]: userdata[item],
               ["userId"]: item,
            };
         });

         console.log(aldfb);

         setGraphData(aldfb);
      }
   }, [estates, users, availableUsers]);

   function renderCustomBarLabel({ payload, x, y, index, width, height, value, altLabel, dataKey, isCurrency, e }) {
      let anzahl = graphData?.[index]?.data?.[dataKey]?.length;

      return (
         <text x={x + width / 2} dx={0} y={y} fill="#fff" fontWeight={500} fontSize={20} textAnchor="middle" dy={-30}>
            {isCurrency && !isNaN(value) && value ? (
               <tspan textAnchor="middle">{Math.round(parseFloat(value / 1000))}</tspan>
            ) : (
               <tspan textAnchor="middle">{value ? value : ""}</tspan>
            )}
            {altLabel && (
               // <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>
               <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>
                  {altLabel}
               </tspan>
            )}
            {anzahl && value ? (
               <tspan fill="#9cf" textAnchor="middle" x={x + width / 2} dy={20} fontWeight={400} fontSize={16}>
                  {anzahl}
               </tspan>
            ) : null}
         </text>
      );
   }

   function CustomTooltip({ active, payload, label }) {
      const isVisible = active && payload && payload.length;
      if (isVisible) {
      }

      return (
         <div
            style={{
               visibility: isVisible ? "visible" : "hidden",
               backgroundColor: "#fffe",
               borderRadius: "10px",
               color: "#000",
               padding: "10px",
               margin: "0 40px",
               boxShadow: "0 0 20px 2px #000",
               // height: 180
            }}
         >
            {isVisible && (
               <>
                  <p className="label">
                     {users[payload[0].payload.userId]
                        ? users[payload[0].payload.userId].Name
                        : users[payload[0].payload.userId]
                          ? users[payload[0].payload.userId]
                          : payload[0].payload.userId}
                  </p>
                  <div>
                     <table style={{ borderCollapse: "collapse", minWidth: 200 }}>
                        <tbody>
                           {Object.keys(payload[0].payload.data).map((item) => {
                              return (
                                 <tr>
                                    <th style={{ textAlign: "left" }}>{item}</th>
                                    <td style={{ textAlign: "right" }}>
                                       {new Intl.NumberFormat("de-DE", {
                                          style: "currency",
                                          currency: "EUR",
                                          maximumFractionDigits: 0,
                                       }).format(parseFloat(payload[0].payload[item]))}
                                    </td>
                                 </tr>
                              );
                           })}
                           <tr>
                              <th style={{ textAlign: "left", borderTop: "1px solid black" }}>Summe</th>
                              <td style={{ borderTop: "1px solid black", textAlign: "right" }}>
                                 <strong>
                                    {new Intl.NumberFormat("de-DE", {
                                       style: "currency",
                                       currency: "EUR",
                                       maximumFractionDigits: 0,
                                    }).format(
                                       Object.keys(payload[0].payload.data).reduce((oldObj, item) => {
                                          return oldObj + parseFloat(payload[0].payload[item]);
                                       }, 0),
                                    )}
                                 </strong>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </>
            )}
         </div>
      );
   }

   return (
      <div
         style={{
            width: "100%",
            position: "absolute",
            right: 0,
            top: 400,
         }}
      >
         <Modal
            size="xl"
            show={selectedData}
            onHide={() => {
               setSelectedData(false);
            }}
         >
            <Modal.Header>
               {selectedData?.name} {selectedData?.key}
            </Modal.Header>
            <Modal.Body>
               <Table className="text-center">
                  <thead>
                     <tr>
                        <th>ObjektNr.</th>
                        <th>Kaufpreis</th>
                        <th>Verkauft für</th>
                        <th>Gesamtprovision</th>
                     </tr>
                  </thead>
                  <tbody>
                     {selectedData?.data?.map((item) => {
                        return (
                           <tr>
                              <td>{item.objektnr_extern}</td>
                              <td>{formatCurrency(item.kaufpreis)}</td>
                              <td>{formatCurrency(item?.[config.estate.verkauftFur])}</td>
                              <td>{formatCurrency(calcProvision(item, config))}</td>
                           </tr>
                        );
                     })}
                  </tbody>
               </Table>
            </Modal.Body>
         </Modal>
         <div
            style={{
               // position: "absolute",

               width: "100%",
               zIndex: 100,
            }}
         >
            <div
               style={{
                  top: -6,
                  zIndex: 101,
                  backgroundColor: "#0006",
                  backdropFilter: "blur(4px)",
                  margin: 0,
                  padding: "10px 0px",
                  position: "sticky",
                  width: "100%",
                  textAlign: "center",
               }}
            >
               <h2 className="mb-3">Summe Provisionsübersicht in k€ (insg. {estates.length})</h2>
               {total &&
                  Object.keys(total).map((keyItem) => {
                     return (
                        <span
                           style={{
                              padding: "2px 10px",
                              margin: "0px 10px",
                              border: "solid 6px " + total[keyItem].color,
                              fontWeight: 500,
                              background: total[keyItem].color + "33",
                           }}
                        >
                           {keyItem}: {total[keyItem].amount}
                           {" Stk. " + "| "}
                           {new Intl.NumberFormat("de-DE", {
                              style: "currency",
                              currency: "EUR",
                              maximumFractionDigits: 0,
                           }).format(parseFloat(total[keyItem].price))}
                        </span>
                     );
                  })}
            </div>
            {graphData && (
               <div>
                  <ResponsiveContainer
                     style={{ background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                     width={"100%"}
                     height={300}
                  >
                     <BarChart
                        barSize={22}
                        // barGap={20}
                        // barCategoryGap={0.4}
                        data={graphData}
                        // layout="vertical"
                        margin={{
                           top: 50,
                           right: 0,
                           left: 0,
                           bottom: 0,
                        }}
                        onClick={(e) => {
                           setSelectedUser(e.activePayload[0].payload.userId);
                           console.log(e.activePayload[0].payload.userId);
                        }}
                     >
                        <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "normal" }} />
                        <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} hide />
                        <Tooltip
                           cursor={false}
                           isAnimationActive={false}
                           // position={{ y: 0, dx: 50 }}
                           content={CustomTooltip}
                        />
                        {/* <Legend /> */}
                        {Object.keys(total).map((keyItem) => {
                           return (
                              <Bar
                                 key={"key_" + keyItem}
                                 // strokeWidth={3}
                                 dataKey={keyItem}
                                 fill={total[keyItem].color}
                                 // fill={total[keyItem].color + "33"}
                                 // stroke={total[keyItem].color}
                                 label={(e) => renderCustomBarLabel({ ...e, isCurrency: true, dataKey: keyItem, e })}
                                 onClick={(e) => {
                                    const { payload } = e;

                                    setSelectedData({
                                       name: payload.name,
                                       key: keyItem,
                                       data: payload?.data?.[keyItem],
                                    });
                                 }}
                              />
                           );
                        })}

                        {/* <Bar
                           key={"key_verkauft"}
                           dataKey={"verkauft"}
                           fill={"#5FD07E"}
                           label={(e) => renderCustomBarLabel({ ...e, isCurrency: true, dataKey: "verkauft", e })}
                           // label={renderCustomBarLabel}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        />
                        <Bar
                           key={"key_gescheitert"}
                           dataKey={"gescheitert"}
                           fill={"#F26D6D"}
                           // label={renderCustomBarLabel}
                           label={(e) => renderCustomBarLabel({ ...e, isCurrency: true, dataKey: "gescheitert", e })}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        /> */}
                     </BarChart>
                  </ResponsiveContainer>
               </div>
            )}
         </div>
      </div>
   );
}
